module.exports = __webpack_public_path__ + "img/image157.0d95ccfe.jpg";